import './Hero.css';
import { AppStoreButton, GooglePlayButton } from '../StoreButtons/StoreButtons';

const ASSETS = {
  bg: `${process.env.PUBLIC_URL}/images/hero/bg.jpg`,
  qr: `${process.env.PUBLIC_URL}/images/hero/qr.png`,
  chevron: `${process.env.PUBLIC_URL}/images/hero/chevron.svg`,
};

function Hero() {
  return (
    <section id="home" className="hero" aria-label="Strona główna">
      <div className="hero__backdrop" aria-hidden="true">
        <img className="hero__bg-image" src={ASSETS.bg} alt="" />
        <div className="hero__gradient" />
      </div>

      <div className="hero__inner">
        <div className="hero__top">
          <div className="hero__copy">
            <h1 className="hero__title">
              Zasługujesz na kogoś kto cię wysłucha.
            </h1>
            <p className="hero__subtitle">
              Odpowiedz na kilka pytań, znajdź osoby, które naprawdę ci pomogą
              i poczuj się lepiej.
            </p>
            <div className="hero__stores">
              <AppStoreButton />
              <GooglePlayButton />
            </div>
          </div>

          <div className="hero__qr">
            <img src={ASSETS.qr} alt="Kod QR do pobrania aplikacji" />
          </div>
        </div>

        <a className="hero__scroll" href="#about">
          <span>zobacz o co chodzi</span>
          <img src={ASSETS.chevron} alt="" aria-hidden="true" />
        </a>
      </div>
    </section>
  );
}

export default Hero;
